<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>国家码设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <Creat></Creat>
        <el-select v-model="selectedValue" clearable placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input placeholder="请输入国家名称" clearable v-model="country">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <div>
        <List :currentPage="page" :currentSize="size" :zh="country"></List>
        <PageNation
          :total="totalCount"
          :size="size"
          :page="page"
          @pageChanged="handlePageChanged($event)"
        ></PageNation>
      </div>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapActions, mapState } from "vuex";
import Creat from "./components/creat";
import List from "./components/list";
import PageNation from "../../../components/pagination";

export default {
  name: "countryCode",
  data() {
    return {
      dialogVisible: false,
      country: "",
      options: [
        {
          value: "zh",
          label: "中文",
        },
        // {
        //   value: "en",
        //   label: "英文",
        // },
        // {
        //   value: "code",
        //   label: "区号",
        // },
      ],
      selectedValue: "zh",
      total: "",
      page: 1,
      size: 10,
      obj: {},
    };
  },
  components: {
    Creat,
    List,
    PageNation,
  },

  computed: {
    ...mapState("countryCode", ["codelist", "totalCount"]),
  },
  methods: {
    ...mapActions("countryCode", ["getlist"]),
    closeDialog() {},
    async handleSearch() {
      // this.obj[this.selectedValue] = this.country;
      this.$set(this.obj,this.selectedValue,this.country)
      const res = await this.getlist({
       ...this.obj,
        page: 1,
        size: this.size,
      });
    },
    handlePageChanged(e) {
      this.page = e.page;
      this.size = e.size;
      this.obj = { ...this.obj, ...e };
      this.getlist({ ...this.obj });
    },
  },
  watch: {
   
    selectedValue: {
      handler(val, oldVal) {
        if (val == "zh") {
          this.obj = {
            zh: "",
          };
          this.handleSearch()
        }
        if(val=='en'){
          this.obj={
            en:''
          }
          this.handleSearch()
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped></style>
